module.exports = __webpack_public_path__ + "img/top_xia.1c9088d0.svg";